import React from 'react'
import { Route, IndexRoute } from 'react-router'
import { StandardLayout } from 'common/layouts/StandardLayout'
import { PairDevicePage } from '../PairDevicePage'

const Wrapper = ({ children }) => (
  <StandardLayout greyBg>
    {children}
  </StandardLayout>
)

export const routes = (
  <Route component={Wrapper}>
    <IndexRoute component={PairDevicePage} />
    <Route path=':shortcode' component={PairDevicePage} />
  </Route>
)
